// extracted by mini-css-extract-plugin
export default {"assign__button":"assignButton_assign__button__FArLb"};